/** @param {{ file_extension?: string, file_type?: string, file_name?: string }} doc */
export function normalizeDocExtension(doc) {
  return String(doc?.file_extension ?? "")
    .trim()
    .replace(/^\./, "")
    .toLowerCase();
}

/** Chỉ coi là PDF khi đuôi / MIME / tên file khớp (phòng DB thiếu trường). */
export function isPdfDocument(doc) {
  if (normalizeDocExtension(doc) === "pdf") return true;
  const mime = String(doc?.file_type ?? "").toLowerCase();
  if (mime === "application/pdf") return true;
  const name = String(doc?.file_name ?? "").toLowerCase();
  if (name.endsWith(".pdf")) return true;
  return false;
}

export async function blobStartsWithPdfMagic(blob) {
  const head = await blob.slice(0, 5).arrayBuffer();
  const prefix = new TextDecoder().decode(head);
  return prefix.startsWith("%PDF");
}

/** Kiểm tra đầu file PDF (%PDF) trên ArrayBuffer đã có sẵn (cache). */
export function arrayBufferStartsWithPdfMagic(buf) {
  if (!buf || buf.byteLength < 4) return false;
  const n = Math.min(5, buf.byteLength);
  const head = new Uint8Array(buf, 0, n);
  const prefix = new TextDecoder().decode(head);
  return prefix.startsWith("%PDF");
}
